/**
 * §F5.9's data model — the constants and the one pure function behind the mini indicator
 * dock and its popover, kept out of the two component files so both stay fast-refreshable
 * and so a test can reach the arithmetic without rendering a widget.
 */
import type { IconName } from '../../lib/icons';

/** §F5.9's six indicators, in the mockup's order (`DOCK_INDS`). */
export const DOCK_INDS = ['b21', 'c21', 'd2', 'e1', 'isfm', 'soc'] as const;

export type DockInd = (typeof DOCK_INDS)[number];

/** The mockup's `DOCK_ICONS` — one stroke glyph per dock indicator. */
export const DOCK_ICONS: Record<DockInd, IconName> = {
  b21: 'shield',
  c21: 'layers',
  d2: 'home',
  e1: 'db',
  isfm: 'draw',
  soc: 'chart',
};

/** §F5.9 "active = gold outline" — the mockup's `#FFD264` (also set in `styles/base.css`). */
export const DOCK_ACTIVE_OUTLINE = '#FFD264';

/**
 * §F5.9's target gauge — `value / target` as a whole percent, capped at 100 as the mockup.
 *
 * `null` whenever the comparison cannot honestly be made (§E4: "'% of target': value /
 * targets[year][scope] when targets present, else omit gauge"), which is what the popover
 * reads to decide whether the `Donut` renders at all.
 */
export function targetPct(value: number | null, target: number | null | undefined): number | null {
  if (value === null || target === null || target === undefined) return null;
  if (!Number.isFinite(value) || !Number.isFinite(target) || target <= 0) return null;
  return Math.min(100, Math.round((value / target) * 100));
}
